export { RiskPage as default } from '@/components/enpages/Ir/Manage/Risk'
